import { SearchIcon } from "@fluentui/react-icons-mdl2";
import { useState } from "react";
import * as Yup from "yup";

import {
  Container,
  ErrorMessage,
  Input,
  InputContainer,
  Label,
  SearchButton,
  SmallButton,
  SmallContainer,
  SmallInput
} from "./style";

import { isDocumentNumberValid } from "@/components/Contracts/AccountStep/SearchClient";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  size?: "large" | "small";
  placeholder?: string;
}

export default function SearchInput({
  value,
  onChange,
  onSearch,
  size = "large",
  placeholder = "Digite o CPF ou CNPJ"
}: SearchInputProps) {
  const [error, setError] = useState<string | null>(null);

  const documentSchema = Yup.string()
    .required("Documento é obrigatório")
    .test("is-valid-document", "Números de CPF ou CNPJ inválidos", value => {
      if (!value) return false;
      const digits = value.replace(/\D/g, "");
      return isDocumentNumberValid(digits);
    });

  const validateDocument = async () => {
    try {
      await documentSchema.validate(value);
      setError(null);
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        setError(err.message);
      }
      return false;
    }
  };

  const handleSearch = async () => {
    const isValid = await validateDocument();
    if (isValid) onSearch();
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleSearch();
  };

  const commonInputProps = {
    type: "text",
    value,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
      if (error) setError(null);
    },
    onKeyPress: handleKeyPress,
    maxLength: 18,
    hasError: !!error
  };

  if (size === "small") {
    return (
      <SmallContainer>
        <div style={{ flex: 1 }}>
          <SmallInput {...commonInputProps} placeholder="CPF ou CNPJ" />
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </div>
        <SmallButton onClick={handleSearch}>
          <SearchIcon />
        </SmallButton>
      </SmallContainer>
    );
  }

  return (
    <Container>
      <InputContainer>
        <Label>Insira o documento do cooperado</Label>
        <Input {...commonInputProps} placeholder={placeholder} />
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </InputContainer>
      <SearchButton onClick={handleSearch} disabled={!value.trim()}>
        <SearchIcon />
        Pesquisar
      </SearchButton>
    </Container>
  );
}
